import React from "react"

type ToggleInputProps = {
  toggled: boolean
  update: (toggled: boolean) => void
}

class ToggleInput extends React.Component<ToggleInputProps> {
  render() {
    return (
      <div className="flex flex-col justify-between h-16">
        <span onClick={() => this.props.update(!this.props.toggled)} className={"border rounded-full border-grey-500 flex items-center cursor-pointer w-12 bg-gray-500 justify-start trans trans-faster" + (this.props.toggled ? ' justify-end bg-green-500' : '')}>
          <span className="rounded-full border w-6 h-6 border-grey-500 shadow-inner bg-white shadow"/>
        </span>
      </div>
    )
  }
}

export default ToggleInput
